// extracted by mini-css-extract-plugin
module.exports = {"donutLabels":"Charts_donutLabels__2dvUM","label":"Charts_label__23B_E"};